import type { OfflineReadiness } from '@ghostscreen/contracts';
import { formatPercent } from '../../i18n/format';
import { i18n } from '../../i18n/i18n';

export type OfflineReadinessPresentation = {
  /** e.g. "Offline readiness: 83%" */
  summary: string;
  /**
   * First blocker reason when percent &lt; 100, e.g.
   * "Weather widget requires connectivity".
   */
  detail: string | null;
  /** Full single-line label for aria / compact cards. */
  label: string;
};

/**
 * Formats content offline readiness for operator UI.
 * Does not invent blockers — only surfaces what deriveOfflineReadiness produced.
 */
export function formatOfflineReadiness(readiness: OfflineReadiness): OfflineReadinessPresentation {
  const summary = i18n.t('offlineReadiness.summary', {
    percent: formatPercent(readiness.percent / 100),
  });

  if (readiness.percent === 100 || readiness.blockers.length === 0) {
    return { summary, detail: null, label: summary };
  }

  const count = readiness.blockers.length;
  const detail = i18n.t('offlineReadiness.detail', {
    count,
    label: readiness.blockers[0]!.label,
    more: count - 1,
  });

  return {
    summary,
    detail,
    label: `${summary} — ${detail}`,
  };
}
